// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"lS","mainContent":"mS","activeSidebar":"nS"};